import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import NewsletterForm from "@/components/NewsletterForm";
import { SOCIALS, PLATFORMS, LOGO_URL } from "@/lib/api";

const ICONS = { Instagram: Instagram };

export default function Footer() {
  return (
    <footer className="dark-section bg-[#121212] text-[#F9F6F0]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <img src={LOGO_URL} alt="Wilder'Squad" className="w-16 h-16 rounded-full mb-5" />
          <h3 className="font-display text-3xl font-bold mb-3">
            Le 3 ricette d'arte di <span className="text-[#D4AF37]">Wilder</span>
          </h3>
          <p className="text-sm text-[#b8b2a4] mb-6 leading-relaxed">
            Iscriviti alla newsletter e ricevi gratis le ricette ispirate ai quadri di Italo Blandolino.
          </p>
          <NewsletterForm dark testId="footer" />
        </div>
        <div className="md:col-span-3">
          <h4 className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-5">Esplora</h4>
          <ul className="space-y-3 text-sm">
            {[
              ["/galleria", "Galleria Italo Blandolino"],
              ["/assaggi-darte", "Assaggi d'Arte"],
              ["/wilder", "Chat Wilder AI"],
              ["/ricette", "Le ricette d'arte"],
              ["/shop", "Shop"],
              ["/corsi", "Corsi & Prodotti Digitali"],
              ["/servizi", "Servizi & Consulenze"],
              ["/blog", "Blog / Magazine"],
              ["/chi-siamo", "Chi Siamo"],
              ["/contatti", "Contatti"],
              ["/admin", "Area riservata"],
            ].map(([to, label]) => (
              <li key={to}>
                <Link to={to} className="ws-link text-[#d8d2c4] hover:text-white">{label}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <h4 className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-5">Seguici</h4>
          <ul className="grid grid-cols-1 gap-2.5 text-sm" data-testid="footer-socials">
            {SOCIALS.map((s) => {
              const Icon = ICONS[s.platform];
              return (
                <li key={`${s.url}-${s.platform}`}>
                  <a href={s.url} target="_blank" rel="noopener noreferrer"
                     className="flex items-center gap-2.5 text-[#d8d2c4] hover:text-[#D4AF37] transition-colors">
                    <Icon size={15} /> <span>{s.handle}</span>
                    <span className="text-[#6b6b6b] text-xs">· {s.platform}</span>
                  </a>
                </li>
              );
            })}
          </ul>
          <h4 className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mt-8 mb-4">Le ricette complete</h4>
          <ul className="space-y-2.5 text-sm" data-testid="footer-platforms">
            {PLATFORMS.map((p) => (
              <li key={p.name}>
                <a href={p.url} target="_blank" rel="noopener noreferrer"
                   className="text-[#d8d2c4] hover:text-[#D4AF37] transition-colors ws-link">
                  {p.name} →
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-[#2A2A2A]">
        <div className="max-w-7xl mx-auto px-5 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#8a8578]">
          <p>© {new Date().getFullYear()} Wildersquad · wildersquad.it · P.IVA in aggiornamento</p>
          <p className="text-center sm:text-right">
            Privacy · Cookie · Wildersquad × minfuell × Wilder<br />
            Immagini protette da diritto d'autore — riutilizzo vietato senza licenza e royalty
          </p>
        </div>
      </div>
    </footer>
  );
}
